import React, { useState } from "react";
import { useNavigate, NavLink } from "react-router-dom";
import { CustomerSidebarData } from "./SidebarData";
import styles from "./Sidebar.module.css";
import logo from "../../assets/logo.svg";

const Sidebar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const navigate = useNavigate();

  const toggleSidebar = () => {
    setIsOpen(!isOpen);
  };

  return (
    <>
      <div
        className={`${styles.overlay} ${isOpen ? styles.active : ""}`}
        onClick={toggleSidebar}
      ></div>
      <div className={styles.burgerIcon} onClick={toggleSidebar}>
        {isOpen ? "✖" : "☰"}
      </div>
      <div className={`${styles.sidebar} ${isOpen ? styles.open : ""}`}>
        <img
          onClick={() => navigate("/customer/dashboard")}
          src={logo}
          alt="Logo"
          className={styles.logo}
        />
        <ul>
          {CustomerSidebarData.map((item, index) => (
            <li key={index}>
              <NavLink
                to={item.path}
                className={({ isActive }) =>
                  isActive ? styles.activeLink : styles.sidebarLink
                }
              >
                {item.title}
              </NavLink>
            </li>
          ))}
        </ul>
      </div>
    </>
  );
};

export default Sidebar;
